import type { $Fetch } from 'nitropack';

import type { OrderPayload, OrderStatus, OrderResponse } from '~/models';

import type { DefaultFilter } from './filter';

export default class OrderService {
  constructor(private fetch: $Fetch) { }

  async count(status?: OrderStatus[]): Promise<number> {
    const store = useAuthStore();

    const userId = store.profile?.userId ?? store.guest?.profile.userId ?? 0;

    return await this.fetch<number>('/orders/count', {
      query: {
        userId,
        status
      }
    });
  }

  async get(uuid: string): Promise<OrderResponse> {
    return await this.fetch<OrderResponse>(`/orders/${uuid}`);
  }

  async list(filter?: DefaultFilter): Promise<OrderResponse[]> {
    const store = useAuthStore();

    return await this.fetch<OrderResponse[]>('/orders/', {
      query: {
        userId: store.profile?.userId ?? 0,
        sortBy: 'date',
        desc: true,
        page: 1,
        limit: 10,
        ...filter
      }
    });
  }

  async post(order: Partial<OrderPayload>): Promise<OrderResponse> {
    return await this.fetch<OrderResponse>('/orders/', {
      method: 'POST',
      body: order
    });
  }

  async put(uuid: string, order: Partial<OrderPayload>): Promise<OrderResponse> {
    return await this.fetch<OrderResponse>(`/orders/${uuid}`, {
      method: 'PUT',
      body: order
    });
  }
}

export type { DefaultFilter as Filter };
